const productionDomain: string = window.location.origin;
const isDirectDevelopmentServer: boolean = process.env.NODE_ENV === 'development' && window.location.port === '3001';
const developmentHost: string = process.env.REACT_APP_API_HOST || window.location.hostname;
const developmentDomain: string = isDirectDevelopmentServer
    ? `${window.location.protocol}//${developmentHost}`
    : productionDomain;
const apiHOST: string = process.env.NODE_ENV === 'development' ? developmentDomain : productionDomain;

const apiPORT: string = process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_API_PORT || (isDirectDevelopmentServer ? '8079' : '')
    : '';
const apiURL: string = `${apiHOST}${apiPORT ? `:${apiPORT}` : ''}/api/dashboard`;
const hostURL: string = `${apiHOST}${apiPORT ? `:${apiPORT}` : ''}`;

const socketPort: string = process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_SOCKET_PORT || apiPORT
    : '';
const socketURL: string = `${apiHOST}${socketPort ? `:${socketPort}` : ''}`;

const socialLoginRedirectUrl: string = process.env.NODE_ENV === 'development' ? hostURL : productionDomain;
const config: any = {
    apiURL,
    socketURL,
    hostURL,
    redirectUrl: socialLoginRedirectUrl,
};

export default config;

window['config'] = config;
